<div class="content-container" [class.loading]="loadingLevel === 'INTEGRATION'">
    <ng-container *ngIf="integration">
        <ng-container
            *ngIf="'import.integrations.providers.' + integration.name.toUpperCase() | translate as integrationName"
        >
            <div class="header">
                <app-header
                    [title]="'import.integrations.steps.preview.subtitle' | translate: { integrationName }"
                    [subtitle]="'import.integrations.steps.preview.description' | translate: { integrationName }"
                    [back]="true"
                    [onBackClick]="onBack.bind(this)"
                >
                    <ui-button
                        (click)="onIntegrationAction()"
                        [openInNewTab]="false"
                        [type]="'primary'"
                        [disabled]="
                            isErrored ||
                            loadingLevel !== null ||
                            (importSummary?.waiting === 0 && importSummary?.total !== 0)
                        "
                        size="mobile-shrink"
                        class="buttons"
                    >
                        {{ 'import.integrations.steps.preview.buttons.importEmployees' | translate }}
                    </ui-button></app-header
                >
                <a href="{{ integrationsHelpLink }}" target="_blank"
                    ><mat-icon svgIcon="help" />{{ 'import.integrations.help' | translate }}</a
                >
            </div>
            <ui-banner *ngIf="isErrored" variant="danger">
                {{ 'import.integrations.steps.preview.employeesError' | translate: { integrationName } }}
            </ui-banner>
            <ui-banner *ngIf="importSummary?.waiting === 0 && importSummary?.total !== 0" variant="warning">
                {{ 'import.integrations.steps.preview.noEmployeesToImport' | translate: { integrationName } }}
            </ui-banner>
            <div class="content-container" [class.loading]="loadingLevel === 'EMPLOYEES'">
                <div *ngIf="importSummary" class="legend">
                    <div>
                        <mat-icon class="success" svgIcon="complete"></mat-icon>
                        {{ 'import.integrations.waiting' | translate }}
                        <span class="margin-left-2">{{ importSummary.waiting }}</span>
                    </div>
                    <div>
                        <mat-icon class="update" svgIcon="refresh"></mat-icon>
                        {{ 'import.integrations.skipped' | translate }}&nbsp;&nbsp;
                        <span class="margin-left-2">{{ importSummary.skipped }}</span>
                    </div>
                    <div>
                        <mat-icon class="warning" svgIcon="error"></mat-icon>
                        {{ 'import.integrations.error' | translate }}&nbsp;&nbsp;
                        <span class="margin-left-2">{{ importSummary.error }}</span>
                    </div>
                </div>
                <app-table
                    *ngIf="importEmployeeTable"
                    [table]="importEmployeeTable"
                    [isResponsive]="true"
                    [showOffset]="true"
                    [noPadding]="true"
                    [embedded]="true"
                    [showSearch]="false"
                    [showLoading]="false"
                    [showPagination]="false"
                >
                    <app-empty-state
                        label="{{ 'employees.directory.noEmployeesFound' | translate }}"
                        src="/assets/illustrations/magnifying-glass.png"
                    >
                    </app-empty-state>
                </app-table>
            </div>
        </ng-container>
    </ng-container>
</div>
